import { BankDetailCreateForm } from "Company/Modules/BankDetail/Components/Form/BankDetailCreateForm";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import type { FC } from "react";

type Props = {
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
	companyId: number;
};

const bankDetailResources = Resources.base.bankDetail.shared;

export const BankDetailCreateModal: FC<Props> = ({
	isOpen,
	setIsOpen,
	companyId,
}) => {
	const { t } = useResource();
	const handleCancel = () => {
		setIsOpen(false);
	};

	return (
		<Dialog open={isOpen} onClose={handleCancel}>
			<DialogTitle>{t(bankDetailResources.addBankDetail)}</DialogTitle>
			<DialogContent sx={{ pb: 1 }}>
				<BankDetailCreateForm companyId={companyId} closeModal={handleCancel} />
			</DialogContent>
		</Dialog>
	);
};
